import { FRUITFUL_ENV } from './config';

export enum FruitfulEnvironment {
    LOCAL = 'local',
    TEST = 'test',
    SANDBOX = 'sandbox',
    STAGING = 'staging',
    PRODUCTION = 'production',
}

const ENV = FRUITFUL_ENV as FruitfulEnvironment;

export const IS_LOCAL = ENV === FruitfulEnvironment.LOCAL;

export const IS_TEST = ENV === FruitfulEnvironment.TEST;

export const IS_STAGING = ENV === FruitfulEnvironment.STAGING;

export const IS_PRODUCTION = ENV === FruitfulEnvironment.PRODUCTION;

export const IS_DEV = [
    FruitfulEnvironment.LOCAL,
    FruitfulEnvironment.SANDBOX,
].includes(ENV);

export const IS_DEPLOYED = [
    FruitfulEnvironment.SANDBOX,
    FruitfulEnvironment.STAGING,
    FruitfulEnvironment.PRODUCTION,
].includes(ENV);
